import { useEffect } from "react";
import { getSceneState } from "../../stores/sceneStore";
import { releaseAssetsInObject } from "../utils/assetUtils";
import { logger } from "../../utils/logger";

export function useHistorySync({
  sceneRef,
  setSceneObjects,
  sceneObjectsRef,
  isHistoryRestoringRef,
}) {
  useEffect(() => {
    const historyListener = () => {
      isHistoryRestoringRef.current = true;
      const mats = getSceneState().materials;
      const robotState = getSceneState();
      // bodies is now a Record, check if it's empty
      if (sceneRef.current && Object.keys(robotState.bodies || {}).length === 0) {
        try {
          const existingRobot = sceneRef.current.getObjectByName("robotGroup");
          if (existingRobot) {
            try {
              releaseAssetsInObject(existingRobot);
            } catch (error) {
              logger.warn("[useHistorySync] Failed to release assets for existing robot", error);
            }
            sceneRef.current.remove(existingRobot);
          }
          sceneObjectsRef.current = {};
          setSceneObjects({});
        } catch (error) {
          logger.warn("[useHistorySync] Failed to reset scene during history restore", error);
        }
      }
      Object.entries(mats || {}).forEach(([materialId, matDef]) => {
        window.dispatchEvent(
          new CustomEvent("material-updated", {
            detail: {
              materialId,
              materialName: matDef?.name,
              updates: matDef,
            },
          })
        );
      });
      setTimeout(() => {
        isHistoryRestoringRef.current = false;
      }, 0);
    };
    window.addEventListener("history-restored", historyListener);
    return () => window.removeEventListener("history-restored", historyListener);
  }, [isHistoryRestoringRef, sceneObjectsRef, sceneRef, setSceneObjects]);
}
